/**
 * Created by richardlovejoy on 3/1/17.
 */

import _ from 'underscore';

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const NumberDisplay = {

  rollCurrent: 0,            // current amount displayed in the cash meter; might be still counting up to what player actually has
  rollTarget: 0,          // amount to roll up to
  countInterval: 0,       // amount to roll per second
  isRolling: false,
  hideLeadingZeroes: false,
  showDigitBack: false,
  padding: 2,

  init(game, parent, x, y, numDigits, digitScale, options) {

    _.extend(this, _.pick(options,
        'rollCurrent', 'rollTarget', 'countInterval', 'isRolling', 'hideLeadingZeroes', 'showDigitBack', 'padding'));

    // create digits
    this.game = game;
    this.digits = [];
    for (let i = 0; i < numDigits; i++) {
      const scale = Array.isArray(digitScale) ? digitScale[i] : digitScale;

      if (this.showDigitBack) {
        const digitBack = this.game.add.image(x, y, 'skee', 'scoreNumBack.png', parent);

        digitBack.scale.set(scale);
      }

      const digit = this.game.add.image(x, y, 'skee', 'scoreNum_000.png', parent);

      digit.scale.set(scale);
      this.digits.push(digit);

      x += digit.width + this.padding;
    }

    // init value
    this.setValue(0);

    return this;
  },

  frameUpdate(dt) {

    if (!this.isRolling)
      return;

    var countInterval = Math.ceil(dt * this.countInterval);
    if (this.rollTarget < this.rollCurrent) {
      countInterval = -countInterval;
    }
    this.setValue(this.rollCurrent + Math.min(countInterval, (this.rollTarget - this.rollCurrent)));

    if (this.rollCurrent === this.rollTarget) {
      this.isRolling = false;
    }
  },

  roll(newValue) {

    // take 1 second to roll
    this.countInterval = Math.abs(newValue - this.rollCurrent);
    this.rollTarget = newValue;

    this.isRolling = true;
  },

  setValue(num) {

    let str = num.toString();
    let char = str.length - this.digits.length;
    this.digits.forEach((digit, idx) => {

      let digitValue = (char < 0) ? 0 : str.charAt(char);
      digit.visible = (char >= 0 || !this.hideLeadingZeroes);
      digit.frameName = 'scoreNum_00'+digitValue+'.png';

      char++;

    });
    this.rollCurrent = num;
  }

};

export default NumberDisplay;



// WEBPACK FOOTER //
// ./app/src/display/meters/NumberDisplay.js